export class TotalField {
  year: string;
  weight: number;

  constructor(year, weight) {
    this.year = year;
    this.weight = weight;
  }
}

export class Aggregate {
  specie_name = '';
  specie_fao_code = '';
  totals: TotalField[] = [];

  addTotal(year, weight) {
    const total = new TotalField(year, weight);
    this.totals.push(total);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/aggregate.ts